/* eslint-disable unicode-bom */
import { useEffect, useState } from "react"
import { MdAddCircleOutline } from 'react-icons/md';
import { registerUser, getUser, saveUser, getUserDetail, ECathegory, TPlayer, TUser, PaymentSection, Section, Input, Select, Heading, EMessageType } from '@sifrovacihra/shared-ui'
import { DisclaimerModal, Player } from "../../components"
import { useAction, useAppState } from "../../store"
import { AUTH_COOKIE, hash, isValidPhone, isValidPlayer, setCookie } from "../../utils"


export const Registration = () => {
    const [name, setName] = useState("")
    const [nameError, setNameError] = useState("")
    const [password, setPassword] = useState("")
    const [passwordError, setPasswordError] = useState("")
    const [phone, setPhone] = useState("")
    const [phoneError, setPhoneError] = useState("")
    const [players, setPlayers] = useState<TPlayer[]>([])
    const { setInfoMessageAction, setTokenAction } = useAction()
    const [showErrors, setShowErrors] = useState(false)
    const [user, setUser] = useState<TUser | undefined>(undefined)
    const { state } = useAppState()
    const [disclaimerModalVisible, setDisclaimerModalVisible] = useState(false)
    const [cathegory, setCathegory] = useState("")
    const [cathegoryError, setCathegoryError] = useState("")

    useEffect(() => {
        console.log("reloaded!!!")
    },[])

    useEffect(() => {
        if (state?.token) {
            getUserDetail({ token: state.token }).then((response) => {
                if (response.user) {
                    setUser(response.user)
                }
            })
        } else {
            setUser(undefined)

            setPlayers([{ Name: '', Id: 1 }, { Name: '', Id: 2 }])
        }
    }, [state?.token])

    useEffect(() => {
        if (user) {
            setName(user.Name)
            setPhone(user.Phone!!)
            if (user.Players) {
                setPlayers(user.Players)
            }
            setCathegory(user.Cathegory || "")
        }
    }, [user])

    const validateForm = (e: React.MouseEvent<HTMLElement>) => {
        console.log(e)
        e.preventDefault()
        window.scrollTo(0, 0);
        setShowErrors(false)
        setInfoMessageAction(undefined)
        setNameError("")
        setPasswordError("")
        setPhoneError("")
        setCathegoryError("")
        let valid = true
        if (name.length < 1) {
            valid = false
            setNameError("Vyplňte název týmu")
        }
        if (!user && password.length < 1) {
            valid = false
            setPasswordError("Vyplňte heslo")
        } else if (!user && password.length < 5) {
            valid = false
            setPasswordError("Heslo musí být dlouhé alespoň 5 znaků")
        }
        if (phone.length < 1) {
            valid = false
            setPhoneError("Vyplňte kontaktní telefon")
        } else if (!isValidPhone(phone)) {
            valid = false
            setPhoneError("Kontaktní telefon nemá správný tvar")
        }
        players.forEach((p, i) => valid = valid && isValidPlayer(p, i, { nameField: 'FullName', fullName: true }))
        if (cathegory === "") {
            valid = false
            setCathegoryError('Zvolte kategorii.')
        }
        if (valid) {
            if (user && state?.token) {
                saveForm(user, state.token)
            } else {
                showDisclaimerModal()
            }
        } else {
            setInfoMessageAction({ type: EMessageType.ALERT, message: 'Ve formuláři se vyskytly chyby.' })
            setShowErrors(true)
        }
    }

    const showDisclaimerModal = () => {
        setDisclaimerModalVisible(true)
    }

    const handleDisclaimerConfirm = () => {
        setDisclaimerModalVisible(false)
        doRegister()
    }

    const doRegister = async () => {
        const regRes = await registerUser({ name: name })
        if (!regRes.token) {
            setInfoMessageAction({ type: EMessageType.ERROR, message: regRes.errorMessage || 'Při registraci nastala neočekávaná chyba.' })
            return
        }
        const token = regRes.token

        const userRes = await getUser({ token })
        const newUser = userRes.user
        if (!newUser || newUser.Id < 0) {
            setInfoMessageAction({ type: EMessageType.ERROR, message: userRes.errorMessage || 'Při registraci nastala neočekávaná chyba.' })
            return
        }

        const fullUser: TUser = {
            ...newUser,
            Password: hash(newUser.Id + password),
            Phone: phone,
            Players: players,
            Cathegory: cathegory,
        }

        const saveRes = await saveUser({ user: fullUser, token })
        if (!saveRes.success) {
            setInfoMessageAction({
                type: EMessageType.ERROR,
                message: (saveRes.errorMessage || 'Registrace se nezdařila.') +
                    ' Tým byl vytvořen, ale nepodařilo se uložit heslo a hráče.' +
                    ' Prosím napište nám na ivana.starkova@mkta.cz a my vám pomůžeme.'
            })
            return
        }

        setCookie({ name: AUTH_COOKIE, value: token })
        setTokenAction(token)
        setUser(fullUser)
        setInfoMessageAction({ type: EMessageType.SUCCESS, message: 'Váš tým byl úspěšně registrovaný.' })
    }

    const saveForm = (currentUser: TUser, token: string) => {
        const userToSave: TUser = {
            ...currentUser,
            Phone: phone,
            Players: players,
            Cathegory: cathegory,
            ...(password.length > 0 ? { Password: hash(currentUser.Id + password) } : {}),
        }
        saveUser({ user: userToSave, token: token }).then((res) => {
            if (res.success) {
                setInfoMessageAction({ type: EMessageType.SUCCESS, message: 'Údaje byly uloženy.' })
                setUser(userToSave)
            } else {
                setInfoMessageAction({ type: EMessageType.ERROR, message: res.errorMessage || 'Při uložení nastala neočekávaná chyba.' })
            }
        })
    }

    const addPlayer = () => {
        if (players.length < 5) {
            setPlayers([...players, { Name: '', Id: (players.length > 0) ? (Math.max(...players.map(p => p.Id)) + 1) : 1 }])
        }
    }

    const removePlayer = (id: number) => {
        let updatedList = players.filter((item) => item.Id !== id)

        setPlayers(updatedList)
    }

    if (!user) return (
        <>
            <Heading headline="Registrace ukončena" weight={1} />
            <Section>
                <p>
                    Registrace byla ukončena. Těší nás velký zájem o hru, ale tetos bohužel nedokžeme připravit materiál pro více jak 65 týmů. Pokud se chcete zúčastnit, můžete napsat na email: <a href="mailto:ivana.starkova@mkta.cz">ivana.starkova@mkta.cz</a> a my vás doregistrujeme v případě, že se uvolní místo.
                </p>
            </Section>
        </>
    )

    return (
        <>
            <DisclaimerModal open={disclaimerModalVisible} handleClose={() => setDisclaimerModalVisible(false)} onAccept={handleDisclaimerConfirm} />
            <Heading headline={user ? "Stránka týmu" : "Přihlásit nový tým"} weight={1} />
            {
                user ? <Section>
                    <p>
                        Zaplacené startovné: {user.Payed ? <span className='payment__yes'>ANO</span> : <span className='payment__no'>NE</span>}
                    </p>
                    {
                        user.Payed ?
                            <>
                                <p> Váš tým je přihlášen na hru! Přesné informace o místě a času registrace se zde objeví v týdnu před hrou. </p>
                                <p> Pokud potřebujete potvrzení o platbě, napište nám na prosím mail: <a href="mailto:ivana.starkova@mkta.cz">ivana.starkova@mkta.cz</a>.</p>
                            </> 
                            : <>
                               <p> Prosím, zaplaťte startovné do 14 dní od registrace, a nejpozději do 20. května, převodem na účet podle následujících instrukcí: </p>
                                <PaymentSection
                                    accountNumber="16026301/0100"
                                    amount={300}
                                    variableSymbol={'2601' + user.Id.toString().padStart(4, '0')}
                                    specificSymbol="602360"
                                    message={'Startovne Sift ' + user.Name}
                                    size={200}
                                />
                        </>

                    }
                    
                </Section>
                    : ''
            }
            <Section >
                {user ? <Heading headline={"Editovat údaje o týmu"} weight={2} /> : ''}
                <Input
                    label="Jméno týmu"
                    value={name}
                    setValue={e => setName(e.target.value)}
                    type="text"
                    required={true}
                    disabled={user ? true : false }
                    errorMessage={nameError}
                />
                <Input
                    label="Heslo"
                    value={password}
                    setValue={e => setPassword(e.target.value)}
                    type="password"
                    required={!user}
                    errorMessage={passwordError }
                />
                <Input
                    label="Kontaktní telefon"
                    value={phone}
                    setValue={e => setPhone(e.target.value)}
                    type="text"
                    required={true}
                    errorMessage={phoneError }
                />
            </Section>
            <Section>
                
                {user && user.Cathegory ?
                    <p>
                        Jste přihlášeni v kategorii: <strong>{ECathegory[user.Cathegory as keyof typeof ECathegory]}</strong>.
                        Pokud potřebujete kategorii změnit, ozvěte se organizátorům na email.
                    </p>
                    :
                    <>
                        <Select
                            label='Kategorie:'
                            options={[{ key: "", label: "Zvolte kategorii" }, { key: "Z", label: ECathegory.Z }, { key: "P", label: ECathegory.P }]}
                            value={cathegory}
                            onChange={setCathegory}
                            errorMessage={cathegoryError}
                        />
                    </>}
                
            </Section>
            <Section>
                <>
                    <Heading headline='Složení týmu' weight={3} />
                    <p>
                        Jméno a příjmení potřebujeme vědět z organizačních důvodů, veřejně zobrazovat budeme pouze přezdívku.
                    </p>
                    {players.map((p, i) => (
                        <Player key={p.Id} player={p} ord={i+1} emailRequired={i === 0} showErrors={showErrors} setPlayers={setPlayers} players={players} removePlayer={removePlayer} />
                    ))}
                    {
                        players.length < 5
                            ? <button className='button secondary' onClick={addPlayer}> <MdAddCircleOutline /> Přidat hráče</button>
                            : ''
                    }
                </>
            </Section>
            <Section centered={true }>
                <button type="button" className='button' onClick={validateForm}> {user ? 'Uložit' : 'Přihlásit se'}</button>
            </Section>
        </>
    )
}
